import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const TabletAppsIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-tabletApps"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M47 3H21a4 4 0 0 0-4 4v20a4 4 0 0 0 4 4h26a4 4 0 0 0 4-4V7a4 4 0 0 0-4-4M21 5h26a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2H21a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M46.5 6h-25A1.5 1.5 0 0 0 20 7.5v19a1.5 1.5 0 0 0 1.5 1.5h25a1.5 1.5 0 0 0 1.5-1.5v-19A1.5 1.5 0 0 0 46.5 6m-25 1h25a.5.5 0 0 1 .5.5v19a.5.5 0 0 1-.5.5h-25a.5.5 0 0 1-.5-.5v-19a.5.5 0 0 1 .5-.5"
        />
        <path
          fill="#0050b3"
          className={styles.interactiveColor}
          d="M25.5 12.5h-1a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1"
        />
        <path
          fill="#0050b3"
          className={styles.interactiveColor}
          fillRule="nonzero"
          d="M25.5 9h-1a1.5 1.5 0 0 0-1.5 1.5v1a1.5 1.5 0 0 0 1.5 1.5h1a1.5 1.5 0 0 0 1.5-1.5v-1A1.5 1.5 0 0 0 25.5 9m-1 1h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5"
        />
        <path
          fill="#0050b3"
          className={styles.interactiveColor}
          d="M31.5 12.5h-1a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1"
        />
        <path
          fill="#0050b3"
          className={styles.interactiveColor}
          fillRule="nonzero"
          d="M31.5 9h-1a1.5 1.5 0 0 0-1.5 1.5v1a1.5 1.5 0 0 0 1.5 1.5h1a1.5 1.5 0 0 0 1.5-1.5v-1A1.5 1.5 0 0 0 31.5 9m-1 1h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5"
        />
        <path
          fill="#0050b3"
          className={styles.interactiveColor}
          d="M37.5 12.5h-1a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1"
        />
        <path
          fill="#0050b3"
          className={styles.interactiveColor}
          fillRule="nonzero"
          d="M37.5 9h-1a1.5 1.5 0 0 0-1.5 1.5v1a1.5 1.5 0 0 0 1.5 1.5h1a1.5 1.5 0 0 0 1.5-1.5v-1A1.5 1.5 0 0 0 37.5 9m-1 1h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5"
        />
        <path
          fill="#0050b3"
          className={styles.interactiveColor}
          d="M43.5 12.5h-1a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1"
        />
        <path
          fill="#0050b3"
          className={styles.interactiveColor}
          fillRule="nonzero"
          d="M43.5 9h-1a1.5 1.5 0 0 0-1.5 1.5v1a1.5 1.5 0 0 0 1.5 1.5h1a1.5 1.5 0 0 0 1.5-1.5v-1A1.5 1.5 0 0 0 43.5 9m-1 1h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5"
        />
        <path
          fill="#0050b3"
          d="M25.5 18.5h-1a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1"
        />
        <path
          fill="#0050b3"
          className={styles.interactiveColor}
          fillRule="nonzero"
          d="M25.5 15h-1a1.5 1.5 0 0 0-1.5 1.5v1a1.5 1.5 0 0 0 1.5 1.5h1a1.5 1.5 0 0 0 1.5-1.5v-1a1.5 1.5 0 0 0-1.5-1.5m-1 1h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5"
        />
        <path
          fill="#0050b3"
          className={styles.interactiveColor}
          d="M25.5 24.5h-1a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1"
        />
        <path
          fill="#0050b3"
          className={styles.interactiveColor}
          fillRule="nonzero"
          d="M25.5 21h-1a1.5 1.5 0 0 0-1.5 1.5v1a1.5 1.5 0 0 0 1.5 1.5h1a1.5 1.5 0 0 0 1.5-1.5v-1a1.5 1.5 0 0 0-1.5-1.5m-1 1h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5"
        />
        <path
          fill="#0050b3"
          className={styles.interactiveColor}
          d="M31.5 24.5h-1a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1"
        />
        <path
          fill="#0050b3"
          className={styles.interactiveColor}
          fillRule="nonzero"
          d="M31.5 21h-1a1.5 1.5 0 0 0-1.5 1.5v1a1.5 1.5 0 0 0 1.5 1.5h1a1.5 1.5 0 0 0 1.5-1.5v-1a1.5 1.5 0 0 0-1.5-1.5m-1 1h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5"
        />
        <path
          fill="#0050b3"
          className={styles.interactiveColor}
          d="M31.5 18.5h-1a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1"
        />
        <path
          fill="#0050b3"
          className={styles.interactiveColor}
          fillRule="nonzero"
          d="M31.5 15h-1a1.5 1.5 0 0 0-1.5 1.5v1a1.5 1.5 0 0 0 1.5 1.5h1a1.5 1.5 0 0 0 1.5-1.5v-1a1.5 1.5 0 0 0-1.5-1.5m-1 1h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5"
        />
        <path
          fill="#0050b3"
          className={styles.interactiveColor}
          d="M37.5 18.5h-1a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1"
        />
        <path
          fill="#0050b3"
          className={styles.interactiveColor}
          fillRule="nonzero"
          d="M37.5 15h-1a1.5 1.5 0 0 0-1.5 1.5v1a1.5 1.5 0 0 0 1.5 1.5h1a1.5 1.5 0 0 0 1.5-1.5v-1a1.5 1.5 0 0 0-1.5-1.5m-1 1h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5"
        />
        <path
          fill="#0050b3"
          className={styles.interactiveColor}
          d="M43.5 18.5h-1a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1"
        />
        <path
          fill="#0050b3"
          className={styles.interactiveColor}
          fillRule="nonzero"
          d="M43.5 15h-1a1.5 1.5 0 0 0-1.5 1.5v1a1.5 1.5 0 0 0 1.5 1.5h1a1.5 1.5 0 0 0 1.5-1.5v-1a1.5 1.5 0 0 0-1.5-1.5m-1 1h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5"
        />
      </g>
    </Icon>
  )
}
